//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";


import shopCart from '@/components/cusShopCart'
import shopCategory from '@/components/shopCategoryList'
import mainMenuTab from '@/components/mainMenuTab'

export default {
    components: {
        shopCart, mainMenuTab,shopCategory
    },

    data(){
        return {
            searchMenu:[],
            current:0,
            caryId:'',
            searchContent:'',
            page:1,
            num:1,
            size:15

        }
    },
    methods:{

        // 查询商品分类列表
        queryGoodsTypeList(){
            let _this = this;
            let opts = {
                url: api.goodsType,
                data:{

                },
                type:'get'
            };
            let allGoodsTitle = { cate_id: -1, cate_name: "全部" }
            common.query(opts).then(res => {

                res.data.unshift(allGoodsTitle)
                    _this.searchMenu = res.data
            },
            res => {
                _this.$vux.toast.text(res.message);
            });
        },

        //返回上一页
        goupPage(){
				this.$router.go(-1)
        },

        // goodsMenuType
        handleChangeSearchTab(id,index){
            this.current = index
            this.$refs.child.querySearchGoods(id,this.searchContent)
            this.caryId = id;
        },

        pullUpLoad(){
          let _this = this;
          let scrollTop = document.documentElement.scrollTop;
          let clientHeight =document.body.clientHeight;
          let pageHeight=document.body.scrollHeight;

          if(scrollTop+clientHeight>=pageHeight){
             _this.page = _this.page+1
            if(this.page <= this.totalPage){
                _this.$refs.child.querySearchGoods(this.caryId)

            }


          }
        },

        //跳转购物车
        goCart(){
            this.$router.push({name: "cart"});
        },

        handleScroll(){
            console.log(1)
        }
    },
    mounted(){
        this.queryGoodsTypeList()
        this.searchContent=this.$route.query.sContent
        document.addEventListener("scroll", this.pullUpLoad,true);

    },
}



// WEBPACK FOOTER //
// ./src/views/pages/search.vue